import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  details: {
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    flexWrap: 'wrap',
    display: 'flex',
    flexDirection: 'row',
    minWidth: 0, // Allow flex items to shrink below their content size
    paddingRight: 6
  },
  label: {
    marginRight: 6,
    fontWeight: 500,
    whiteSpace: 'nowrap', // Keep label on one line
  },
  value: {
    fontWeight: 600,
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    minWidth: 0, // Allow text to wrap and shrink
  },
  noWrap: {
    flexWrap: 'nowrap',
  }
});

const Details = ({ classes, label, value, noWrap }) => {  return (
    <div className={`${classes.details} ${noWrap ? classes.noWrap : ''}`}>    
        <span className={classes.label}>{label}</span>
        <span className={classes.value}>{value}</span>
    </div>
  );
};

export default withStyles(styles)(Details);
